import React from "react";
import DynamicForm from "./DynamicForm";

function SettingComponent({ settingsName, settings,settingsHandlechange }) {
    const handleChange=(e,index, name,value)=>{

        // console.log("value",value);
        // console.log("name",name);
        // console.log("index",index);
        // console.log("e",e);
        settingsHandlechange && settingsHandlechange(e,index, name,value)
    }
//   const data = [
//     {
//       name: "Do you provide pickup delivery ?",
//       description: "If on than user will not pay delivery fees",
//       inputType: {
//         label: "Boolean",
//         type: "range",
//         attributes: {
//           text: ["name", "id", "value", "autocomplete", "title"],
//           boolean: ["required", "readonly", "disabled", "autofocus", "checked"],
//         },
//       },
//       selected_attribute: {
//         required: true,
//         name: "price_range",
//         id: "price_range",
//       },
//     },
//     {
//       name: "Do you provide delivery?",
//       description: "If on than user will pickup order from store",
//       inputType: {
//         label: "Boolean",
//         type: "checkbox",
//         attributes: {
//           text: ["name", "id", "value", "autocomplete", "title"],
//           boolean: ["required", "readonly", "disabled", "autofocus", "checked"],
//         },
//       },
//       selected_attribute: {
//         required: true,
//         name: "price_range",
//         id: "price_range",
//       },
//     },
//     {
//       name: "Min. & max. delivery time",
//       description: "Approximate delivery time to show user",
//       inputType: {
//         label: "Boolean",
//         type: "checkbox",
//         attributes: {
//           text: ["name", "id", "value", "autocomplete", "title"],
//           boolean: ["required", "readonly", "disabled", "autofocus", "checked"],
//         },
//       },
//       selected_attribute: {
//         required: true,
//         name: "price_range",
//         id: "price_range",
//       },
//     },
//   ];
  return (
    <>
      <div className="n-card">
        <h1>{settingsName}</h1>
        <div className="d-flex flex-column gap-1 my-1">
          {settings.length ?settings.map((items, i) => (
            <div
              key={i}
              className="d-flex justify-content-between align-items-center"
            >
              <div>
                <p>{items.name}</p>
                <p>{items.description}</p>
              </div>
              <DynamicForm
                index={i}
                inputType={items.inputType}
                selectedAttributes={items.selected_attribute}
                handleChange={handleChange}
              />
            </div>
          )):""}
        </div>
      </div>
    </>
  );
}

export default SettingComponent;
